module.exports = __webpack_public_path__ + "img/jiaoyan.8d8de3e5.png";